"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POOL_UPDATE = exports.STAKING_POOLS = exports.POOL_SNAPSHOTS = exports.TOKEN_DAYS_DATA = exports.ALL_POOLS = exports.POOL_BY_ID = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const dailySnapshotPartialBody = `
id
date
value
totalSupply
feesTotalUSD
totalValueLockedUSD
totalSwapVolumeUSD
totalVolumeUSD
`;
const indexPoolPartialBody = `
id
category {
  id
}
size
name
symbol
isPublic
totalSupply
totalWeight
swapFee
exitFee
feesTotalUSD
totalValueLockedUSD
totalVolumeUSD
totalSwapVolumeUSD
tokensList
poolInitializer {
  id
  totalCreditedWETH
  tokens {
    token {
      id
      decimals
      name
      symbol
      priceUSD
    }
    balance
    targetBalance
    amountRemaining
  }
}
tokens {
  id
  token {
    id
    decimals
    name
    symbol
    priceUSD
  }
  ready
  balance
  minimumBalance
  denorm
  desiredDenorm
}
dailySnapshots(orderBy: date, orderDirection: desc, first: 168) {
  ${dailySnapshotPartialBody}
}
`;
exports.POOL_BY_ID = graphql_tag_1.default `
query poolById($poolId: Bytes!) {
  indexPool(id: $poolId) {
    ${indexPoolPartialBody}
  }
}
`;
exports.ALL_POOLS = graphql_tag_1.default `
query allPools {
  indexPools(first: 100) {
    ${indexPoolPartialBody}
  }
}
`;
exports.TOKEN_DAYS_DATA = graphql_tag_1.default `
query tokenDayData($tokenId: Bytes!, $days: Int!) {
  tokenDayDatas(
    orderBy: date,
    orderDirection: desc,
    first: $days,
    where: { token: $tokenId }
  ) {
    date
    priceUSD
  }
}
`;
exports.POOL_SNAPSHOTS = graphql_tag_1.default `
query snapshots($poolId: Bytes!, $hours: Int!) {
  indexPool(id: $poolId) {
    dailySnapshots(orderBy: date, orderDirection: desc, first: $hours) {
      ${dailySnapshotPartialBody}
    }
  }
}
`;
exports.STAKING_POOLS = graphql_tag_1.default `
query stakingPools {
  ndxStakingPools(first: 100) {
    id
    isWethPair
    startsAt
		isReady
    indexPool
    stakingToken
    totalSupply
    periodFinish
    lastUpdateTime
    totalRewards
    claimedRewards
    rewardRate
    rewardPerTokenStored
  }
}
`;
exports.POOL_UPDATE = graphql_tag_1.default `
query lastHourPoolData($poolId: Bytes!) {
  indexPool(id: $poolId) {
    dailySnapshots(orderBy: date, orderDirection: desc, first: 1) {
      ${dailySnapshotPartialBody}
    }
    tokens {
      token {
        id
        priceUSD
      }
    }
  }
}
`;
